/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Activity_Unknownrarity1Inputs */

const id_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelangkaan tidak diketahui`)
};

const ms_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecelaruan tidak diketahui`)
};

const da_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukendt sjældenhed`)
};

const de_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannte Seltenheit`)
};

const en_us2_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown rarity`)
};

const es_es2_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rareza desconocida`)
};

const es_mx2_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rareza desconocida`)
};

const fil_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi kilalang rarity`)
};

const fr_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rareté inconnue`)
};

const it_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rarità sconosciuta`)
};

const hu_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismeretlen ritkaság`)
};

const nl_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbekende zeldzaamheid`)
};

const no_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukjent sjeldenhet`)
};

const pl_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieznana rzadkość`)
};

const pt_br2_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raridade desconhecida`)
};

const pt_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raridade desconhecida`)
};

const ro_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raritate necunoscută`)
};

const fi_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntematon harvinaisuus`)
};

const sv_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okänd sällsynthet`)
};

const vi_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Độ hiếm không xác định`)
};

const tr_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmeyen nadirlik`)
};

const cs_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámá vzácnost`)
};

const bg_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Непозната рядкост`)
};

const ru_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестная редкость`)
};

const uk_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невідома рідкість`)
};

const ar_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ندرة غير معروفة`)
};

const hi_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात दुर्लभता`)
};

const th_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความหายากไม่ทราบ`)
};

const ja_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不明なレアリティ`)
};

const zh_cn2_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知稀有度`)
};

const zh_hant1_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知稀有度`)
};

const ko_profile_activity_unknownrarity1 = /** @type {(inputs: Profile_Activity_Unknownrarity1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알 수 없는 희귀도`)
};

/**
* | output |
* | --- |
* | "Unknown rarity" |
*
* @param {Profile_Activity_Unknownrarity1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_unknownrarity1 = /** @type {((inputs?: Profile_Activity_Unknownrarity1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_Unknownrarity1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_unknownrarity1(inputs)
	if (locale === "ms") return ms_profile_activity_unknownrarity1(inputs)
	if (locale === "da") return da_profile_activity_unknownrarity1(inputs)
	if (locale === "de") return de_profile_activity_unknownrarity1(inputs)
	if (locale === "en-US") return en_us2_profile_activity_unknownrarity1(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_unknownrarity1(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_unknownrarity1(inputs)
	if (locale === "fil") return fil_profile_activity_unknownrarity1(inputs)
	if (locale === "fr") return fr_profile_activity_unknownrarity1(inputs)
	if (locale === "it") return it_profile_activity_unknownrarity1(inputs)
	if (locale === "hu") return hu_profile_activity_unknownrarity1(inputs)
	if (locale === "nl") return nl_profile_activity_unknownrarity1(inputs)
	if (locale === "no") return no_profile_activity_unknownrarity1(inputs)
	if (locale === "pl") return pl_profile_activity_unknownrarity1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_unknownrarity1(inputs)
	if (locale === "pt") return pt_profile_activity_unknownrarity1(inputs)
	if (locale === "ro") return ro_profile_activity_unknownrarity1(inputs)
	if (locale === "fi") return fi_profile_activity_unknownrarity1(inputs)
	if (locale === "sv") return sv_profile_activity_unknownrarity1(inputs)
	if (locale === "vi") return vi_profile_activity_unknownrarity1(inputs)
	if (locale === "tr") return tr_profile_activity_unknownrarity1(inputs)
	if (locale === "cs") return cs_profile_activity_unknownrarity1(inputs)
	if (locale === "bg") return bg_profile_activity_unknownrarity1(inputs)
	if (locale === "ru") return ru_profile_activity_unknownrarity1(inputs)
	if (locale === "uk") return uk_profile_activity_unknownrarity1(inputs)
	if (locale === "ar") return ar_profile_activity_unknownrarity1(inputs)
	if (locale === "hi") return hi_profile_activity_unknownrarity1(inputs)
	if (locale === "th") return th_profile_activity_unknownrarity1(inputs)
	if (locale === "ja") return ja_profile_activity_unknownrarity1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_unknownrarity1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_unknownrarity1(inputs)
	return ko_profile_activity_unknownrarity1(inputs)
});
export { profile_activity_unknownrarity1 as "profile.activity.unknownRarity" }